<template>
  <div>
    <asc-label-box
      :bg-color="calcBgColor"
      :color="calcColor"
      :value="value"
    ></asc-label-box>
  </div>
</template>

<script>
import AscLabelBox from './AscLabelBox'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscGrayLabelBox',

  components: {
    AscLabelBox,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    calcBgColor() {
      return variables.gray300
    },
    calcColor() {
      return variables.primaryblack
    },
  },
}
</script>
